import * as React from "react";
import { Icon } from "../frame/Icon.jsx";
import { ComponentType } from "../frame/ComponentType.js";
import * as cls from "./Button.module.scss";
const cType = new ComponentType("Button", "btn_", cls);
export { Button };
/**
 * Кнопка.
 * @param {Object} props - Атрибуты элемента.
 * @param {"primary"|"danger"|"default"} [props.type=default] - Тип кнопки.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {string} [props.icon] - Имя иконки.
 * @param {EventListener} [props.onClick] - При нажатии кнопки.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../frame/Icon.jsx}, {@link ../frame/EventListener.js}
 * @example
 * import {Button} from "../personal-studio-components/form/index.js";
 * <Button icon="sent" onClick={(event) => {event.preventDefault();}}>
 *   Отправить
 * </Button>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Button(
  {
    type = "default",
    className,
    icon,
    disabled,
    onClick,
    children
  }) {
  const fullClassName = cType.getFullClassName(type, className);
  const widgetIcon = icon ?
    <Icon name={icon} className={cls.btn_icon} /> : null;
  return (
    <button
      type="submit"
      className={fullClassName}
      disabled={disabled}
      onClick={onClick}>
      {widgetIcon}
      {children}
    </button>
  );
}
/** 
 * Типы кнопок.
 * @enum {string}
 * @inner
 */
Button.Type =
{
  /** Основное действие. */
  PRIMARY: "primary",
  /** Второстепенное действие. */
  SECONDARY: "secondary",
  /** Красная кнопка: опасное действие или ошибка. */
  DANGER: "danger",
  /** По умолчанию. */
  DEFAULT: "default"
};
